import React from "react";
import moment from "moment";

import DateInput from "../../../../parts/inputs/date-input";
import NutritionHistoryTable from "./NutritionHistoryTable";
import { getDateToDisplay } from "../../../../utils/nutrition-helpers";
import CheckboxInput from "../../../../parts/checkbox-input";
import Dropdown from "../../../../parts/dropdown";

const NutritionHistory = ({
  dateFrom,
  dateTo,
  stats,
  averageStats,
  activeDayUtc,
  nutritionPlans,
  selectedPlan,
  handleDateChange,
  handleActiveDayChange,
  handleSelectedPlanChange,
  activeUser,
  isActiveDayPeriod,
  showAveragesOnly,
  handleShowAveragesOnly,
  activeExercises,
}) => {
  const { units } = activeUser;

  const completeStats = stats
    .concat(averageStats)
    .sort((a, b) => b.utcDate - a.utcDate);
  const getDropdownLabel = () => {
    return selectedPlan
      ? `${getDateToDisplay(selectedPlan.utcStartDate)} -
  ${getDateToDisplay(selectedPlan.utcEndDate)}`
      : nutritionPlans.length
      ? "Select a Plan"
      : "No plans created";
  };
  return (
    <>
      <header>
        <hgroup>
          <label>Select a plan:</label>
          <div>
            <Dropdown
              summaryText={getDropdownLabel()}
              options={nutritionPlans.map((plan) => {
                return {
                  text: `${getDateToDisplay(plan.utcStartDate)} -
                ${getDateToDisplay(plan.utcEndDate)}`,
                  value: plan._id,
                };
              })}
              onSelectFn={handleSelectedPlanChange}
            />
            <CheckboxInput
              inputName="showAverage"
              id="showAverageOnly"
              value="kcal"
              // className="radio"
              checked={showAveragesOnly}
              onChangeFn={handleShowAveragesOnly}
              labelText={"Show Averages only"}
            />
          </div>
        </hgroup>
        <hgroup className="mobile-hidden">
          <label>Reporting Period</label>
          <div role="calendar-date-selectors">
            <DateInput
              name="from"
              placeholder="Start Date"
              value={dateFrom}
              max={dateTo}
              onChange={(date) => handleDateChange(date, "dateFrom")}
            />
            <span>to</span>
            <DateInput
              name="to"
              placeholder="End Date"
              value={dateTo}
              min={dateFrom}
              onChange={(date) => handleDateChange(date, "dateTo")}
              alignRight={true}
            />
          </div>
        </hgroup>
      </header>
      <section className="nutrition-history">
        {completeStats.length ? (
          <NutritionHistoryTable
            units={units}
            nutritionHistory={showAveragesOnly ? averageStats : completeStats}
            activeDayUtc={activeDayUtc}
            handleActiveDayChange={handleActiveDayChange}
            isActiveDayPeriod={isActiveDayPeriod}
            nutritionPlans={nutritionPlans}
            activeExercises={activeExercises}
          />
        ) : (
          <div className="no-data">No data to show</div>
        )}
      </section>
    </>
  );
};

export default NutritionHistory;
